module.exports = __webpack_public_path__ + "116046115efec1fd28690ca77e004355.png";